import type { Action } from 'state/actions';
import { addOrPatchKey, removeKey, removeKeyIfEmpty, replaceKeyIfExist } from 'state/utils/collection';

import type { DocumentDownloadState } from './model';

export function documentDownloadReducer(state: DocumentDownloadState = {}, action: Action): DocumentDownloadState {
  switch (action.type) {
    case 'DOCUMENT_DOWNLOAD_FAILED': {
      const docFormat = action.documentFormat.toString();
      return addOrPatchKey(state, action.tabId, documents => {
        return addOrPatchKey(documents, action.document, locales => {
          return addOrPatchKey(locales, action.locale, docFormats => ({
            ...docFormats,
            [docFormat]: { status: 'error' as const, error: action.error },
          }));
        });
      });
    }
    case 'DOCUMENT_DOWNLOAD_START': {
      const docFormat = action.documentFormat.toString();
      return addOrPatchKey(state, action.tabId, documents => {
        return addOrPatchKey(documents, action.document, locales => {
          return addOrPatchKey(locales, action.locale, docFormats => ({
            ...docFormats,
            [docFormat]: { status: 'loading' as const },
          }));
        });
      });
    }

    case 'DOCUMENT_DOWNLOADED': {
      const docFormat = action.documentFormat.toString();
      return removeKeyIfEmpty(
        replaceKeyIfExist(state, action.tabId, documents => {
          return removeKeyIfEmpty(
            replaceKeyIfExist(documents, action.document, locales =>
              removeKeyIfEmpty(
                replaceKeyIfExist(locales, action.locale, docFormats => removeKey(docFormats, docFormat)),
                action.locale,
              ),
            ),
            action.document,
          );
        }),
        action.tabId,
      );
    }

    case 'QUOTE_REMOVED':
    case 'FORM_ENRICHMENT_RECEIVED':
      return removeKey(state, action.tabId);
  }

  return state;
}
